export default __webpack_public_path__ + "static/media/forum.8bf4905b.svg";